import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import server from '../../../api/server';
import { fetchApplication } from '../../../actions';
import Modal, { ModalBody, ModalFooter } from '../ui/Modal';
import Button from '../ui/Button';
import DocRequestChecklist from './DocRequestChecklist';

// Redesign of newadmin/elements/EditDocCollectionModal.js — same
// /docrequest/edit payload shape ({ organisation_id, state, application_id })
// followed by fetchApplication.
const EditDocCollectionModal = ({ open, onClose }) => {
    const documents = useSelector((s) => s.admin.active_application.documents);
    const activeApplication = useSelector((s) => s.admin.active_application);
    const organisation = useSelector((s) => s.organisation);
    const dispatch = useDispatch();

    const [applicants, setApplicants] = useState({});
    const [disabled, setDisabled] = useState(false);

    const buildApplicants = () => {
        if (documents == null) return;
        const next = {};
        Object.keys(documents.applicants).forEach((key) => {
            const files = [];
            organisation.file_upload_settings.files.forEach((file, index) => {
                let requested = false;
                const fileKey = file.label.toLowerCase().replace(/ /g, '_');
                if (
                    documents.applicants[key].requested_documents != undefined &&
                    documents.applicants[key].requested_documents[fileKey] != undefined
                ) {
                    requested = true;
                }
                files.push({
                    label: file.label,
                    index: index,
                    description: file.description,
                    min_documents: file.min_documents,
                    requested: requested,
                    category: file.category,
                });
            });
            next[key] = {
                name: documents.applicants[key].name,
                files: [...files],
            };
        });
        setApplicants(next);
    };

    // Rebuild the checklist from the current requested_documents whenever the
    // modal opens (port of componentDidMount/componentDidUpdate sync).
    useEffect(() => {
        if (open) {
            buildApplicants();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    const toggleFile = (applicantKey, fileIndex) => {
        const next = { ...applicants };
        next[applicantKey].files[fileIndex].requested = !next[applicantKey].files[fileIndex].requested;
        setApplicants(next);
    };

    const selectAll = (applicantKey) => {
        const next = { ...applicants };
        next[applicantKey].files.forEach((file) => {
            file.requested = true;
        });
        setApplicants(next);
    };

    const submitEdit = async () => {
        setDisabled(true);
        const response = await server.post('/docrequest/edit', {
            organisation_id: organisation.id,
            // Original sent the whole component state ({ disabled, applicants }).
            state: { disabled: true, applicants },
            application_id: activeApplication.application.id,
        });
        if (response.data) {
            dispatch(fetchApplication(activeApplication.application.id));
        }
        setDisabled(false);
        onClose();
    };

    return (
        <Modal open={open} onClose={onClose} title="Edit Document Collection" size="xl">
            <ModalBody className="flex-1">
                <DocRequestChecklist applicants={applicants} onToggle={toggleFile} onSelectAll={selectAll} />
            </ModalBody>
            <ModalFooter>
                <Button variant="secondary" onClick={onClose}>
                    Close
                </Button>
                <Button disabled={disabled} onClick={submitEdit}>
                    Edit Document Collection
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default EditDocCollectionModal;
